// Big number + small label.
// Usage: <StatBlock value="3" label="RINGS" color="gold" />

export default function StatBlock({ value, label, color = 'default', size = 'md', className = '' }) {
  const colorClass = {
    gold: 'text-accent-gold',
    red: 'text-accent-red',
    default: 'text-ink-primary',
  }[color] || 'text-ink-primary';

  const sizeClass = {
    sm: 'text-2xl',
    md: 'text-4xl',
    lg: 'text-5xl',
    xl: 'text-7xl',
  }[size] || 'text-4xl';

  return (
    <div className={className}>
      <div className={`${sizeClass} font-black leading-none ${colorClass}`}>{value}</div>
      <div className="text-[9px] font-bold text-ink-tertiary tracking-[0.2em] mt-1.5">{label}</div>
    </div>
  );
}
